/**
 * Analyst report links (FB-COV-2/3) + entity logo helpers.
 *
 * For now we use TipRanks (US/UK), Zacks (US fallback), and Moneycontrol
 * (India). Each is a deterministic URL — no API key needed. We open them
 * in the user's native browser via openExternal so PWA users don't get
 * trapped in the webview.
 */

/**
 * Build an analyst-coverage URL for the given asset.
 *
 * @param {object} asset { symbol, asset_type, region }
 * @returns {string|null} URL or null when not applicable.
 */
export function analystUrlFor(asset) {
  if (!asset) return null;
  const type = asset.asset_type || asset.kind;
  const sym = (asset.symbol || '').trim();
  if (!sym) return null;

  if (type === 'stock') {
    if (asset.region === 'IN') {
      // Moneycontrol page for NSE tickers — we link to the search since the
      // exact slug varies by company.
      return `https://www.moneycontrol.com/india/stockpricequote/search/?search_str=${encodeURIComponent(sym)}`;
    }
    if (asset.region === 'GB') {
      // TipRanks UK forecast page.
      return `https://www.tipranks.com/stocks/${sym.toLowerCase()}.l/forecast`;
    }
    // Default to US TipRanks.
    return `https://www.tipranks.com/stocks/${sym.toLowerCase()}/forecast`;
  }

  if (type === 'crypto') {
    return `https://www.coingecko.com/en/coins/${sym.toLowerCase()}`;
  }

  if (type === 'forex') {
    // FX pair like "GBP/USD" — strip slash.
    const cleaned = sym.replace('/', '').toLowerCase();
    return `https://www.dailyfx.com/${cleaned}`;
  }

  return null;
}

/**
 * Logo URL for a stock ticker — Clearbit first, fallback to a colour band
 * (the user explicitly chose 'colour bands only' for Phase C, so this is
 * available as opt-in only).
 */
export function logoUrlFor(asset) {
  // Reserved for a future Phase C iteration; user opted out of card images.
  void asset;
  return null;
}
